import { IGNITION_TUNING } from './ignitionTuning'

/**
 * Optional audio slots for the pressure-release sequence.
 *
 * Add the two files below to `public/media/sounds/`, then enable the matching
 * slot. Keeping them disabled avoids repeated 404 requests while the bespoke
 * sound design is still missing. Both channels still pass through Nova's
 * global SFX toggle and master volume.
 */
export const IGNITION_SFX_TUNING = {
  tab: {
    enabled: true,
    src: `${import.meta.env.BASE_URL}media/sounds/ignition-tab.mp3`,
    volume: 0.54,
    playbackRate: 1.2,
    delayMs: 260,
  },
  beam: {
    enabled: true,
    id: 'ignition-beam',
    src: `${import.meta.env.BASE_URL}media/sounds/ignition-beam.mp3`,
    volume: 0.78,
    delayMs:
      IGNITION_TUNING.scene.tensionMs + IGNITION_TUNING.scene.energyDelayMs,
    fadeInMs: IGNITION_TUNING.scene.energyRiseMs,
    fadeOutMs: 2_200,
  },
} as const
